import React             from 'react';
import { ErrorBoundary } from '../atoms/ErrorBoundary';
import { HelpTemplate }  from '../templates/Help/Help';

export class Help extends React.PureComponent {
    render() {
        return (
            <ErrorBoundary>
                <HelpTemplate />
            </ErrorBoundary>
        );
    }
}
